<template>
  <path
    d="M9.99997 9.00017V7.41017C9.99997 6.52017 8.91997 6.07017 8.28997 6.70017L3.69997 11.2902C3.30997 11.6802 3.30997 12.3102 3.69997 12.7002L8.28997 17.2902C8.91997 17.9202 9.99997 17.4802 9.99997 16.5902V14.9002C15 14.9002 18.5 16.5002 21 20.0002C20 15.0002 17 10.0002 9.99997 9.00017Z"
  />
</template>
